// import { useEffect, useState } from 'react';
import { Field } from 'formik';
import { fromJS } from 'immutable';
import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';
import SelectTextFieldFormik from 'app/components/form/formik/SelectTextFieldFormik';
import withStyles from '@material-ui/styles/withStyles';
import { Grid } from '@material-ui/core';
import DropdownOption from 'features/wells/schematics/components/DropdownOption';
import { SCHEMATIC_FORM_VALUES } from 'features/wells/schematics/helpers/constants';
import { startCase } from 'lodash';

const SchematicFormFeilds = ({
  classes,
  allElements,
  lengthUnit,
  widthUnit,
}) => {
  // const { values } = useFormikContext();
  // const [selectedComponent, setSelectedComponent] = useState({
  //   image: '',
  //   display: false,
  // });

  // useEffect(() => {
  //   if (values[SCHEMATIC_FORM_VALUES.COMPONENT]) {
  //     const selectedComponentImage = allElements.find(
  //       (element) => element.name === values[SCHEMATIC_FORM_VALUES.COMPONENT],
  //     );
  //     setSelectedComponent({
  //       display: true,
  //       image: selectedComponentImage.svgDataBase64,
  //     });
  //   }
  //   // eslint-disable-next-line
  // }, [values[SCHEMATIC_FORM_VALUES.COMPONENT]]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SelectTextFieldFormik
          label="Component"
          margin="none"
          items={fromJS(allElements)}
          name={SCHEMATIC_FORM_VALUES.COMPONENT}
          getItemValue={(element) => element.get('name')}
          getItemName={(element) => <DropdownOption element={element} />}
          displayEmpty={false}
          SelectProps={{
            renderValue: (selected) => startCase(selected),
          }}
        />
      </Grid>
      {/* <Grid item xs={selectedComponent.display ? 9 : 12}> */}
      <Grid item xs={12}>
        <Field
          multiline
          fullWidth
          component={TextFieldFormik}
          minRows={3}
          name={SCHEMATIC_FORM_VALUES.DESCRIPTION}
          label="Description"
          type="text"
          className={classes.textfieldLabel}
          variant="outlined"
        />
      </Grid>
      {/* {selectedComponent.display && (
        <Grid item xs={3} className={classes.svgImageGrid}>
          <img
            src={`data:image/svg+xml;base64,${selectedComponent.image}`}
            alt={values[SCHEMATIC_FORM_VALUES.COMPONENT]}
            className={classes.svgImage}
          />
        </Grid>
      )} */}

      <Grid className={classes.fieldWrapper} item xs={12}>
        <Grid item xs={6} className={classes.field}>
          <Field
            required
            type="number"
            label={`Start Depth (${lengthUnit})`}
            name={SCHEMATIC_FORM_VALUES.START_DEPTH}
            component={TextFieldFormik}
          />
        </Grid>
        <Grid item xs={6} className={classes.field}>
          <Field
            required
            type="number"
            label={`End Depth (${lengthUnit})`}
            destroyOnUnmount
            name={SCHEMATIC_FORM_VALUES.END_DEPTH}
            component={TextFieldFormik}
          />
        </Grid>
      </Grid>
      <Grid className={classes.fieldWrapper} item xs={12}>
        <Grid item xs={6} className={classes.field}>
          <Field
            required
            type="number"
            label={`Inner Diameter (${widthUnit})`}
            name={SCHEMATIC_FORM_VALUES.INNER_DIAMETER}
            component={TextFieldFormik}
          />
        </Grid>
        <Grid item xs={6} className={classes.field}>
          <Field
            required
            type="number"
            label={`Outer Diameter (${widthUnit})`}
            name={SCHEMATIC_FORM_VALUES.OUTER_DIAMETER}
            component={TextFieldFormik}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
const styles = (theme) => ({
  fieldWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textfieldLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      background: theme.palette.background.default,
    },
    '& .MuiOutlinedInput-root': {
      textarea: {
        minHeight: theme.spacing(4),
      },
    },
  },

  field: {
    padding: theme.spacing(1),
  },
  svgImage: {
    width: theme.spacing(12),
    height: theme.spacing(12),
    marginRight: theme.spacing(1),
  },
  svgImageGrid: {
    display: 'flex',
    alignItems: 'center',
  },
});

export default withStyles(styles)(SchematicFormFeilds);
